import { request } from '@src/utils/request';
import type { MyCityMapItem, SystemGeoItem } from './types';

// GET /api/map/citymap/myVrDoorCityMapList 查询已开通城市地图列表
export const getMapCitymapMyVrDoorCityMapList = () =>
    request<MyCityMapItem[]>({
        url: '/api/map/citymap/myVrDoorCityMapList',
        method: 'get',
        // params: {
        //     packageId: '15', // TODO: 套餐 ID 先写死，当前套餐为任意门套餐 ID
        // },
    });

// POST /api/system/geo/list - 获取城市列表
export const postSystemGeoList = () =>
    request<SystemGeoItem[]>({
        url: '/api/system/geo/list',
        method: 'post',
    });
